import * as yup from "yup";

import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

import createGenericQueueSchema from "../../schema/createGenericQueueSchema";

const schema = createGenericQueueSchema().concat(
  yup.object().shape({
    whisper_audio_id: yup.string().nullable(),
    call_recording_percentage: yup.number().min(0).max(100),
    waiting_audio_id: yup.string().nullable(),
    voicemail_enabled: yup.bool(),
    voicemail_message_deliver: yup.string().nullable(),
    voicemail_message_main: yup.string().nullable(),
    voicemail_message_optional: yup.string().nullable(),
    voicemail_message_required: yup.string().nullable(),
    voicemail_queue_id: yup.string().nullable(),
  })
);

export default addKeyToFieldsRecursively(schema);
